export default {"src":"/_next/static/media/hape_logo.a3887ea8.svg","height":27,"width":162,"blurWidth":0,"blurHeight":0};